import i18next from "i18next";
import {
  loginConstants,
  userConstants,
  centersConstants,
  globalSystemConstants,
  contentType,
} from "../../constants";
import { instructorActions } from "../actions";
import { ToastifyService, centersService, authService } from "../../services";
import { success, custom } from "./utilities";
import { downloadBase64File } from "../../system";

const {
  PENDING_CENTERS_LIST,
  CENTER_DATA_BY_ID,
  APPROVED_CENTERS_LIST,
  GET_CENTER_LOGO,
  CENTER_SPOT_DATA_BY_ID,
  CENTERS_LIST,
  IS_CENTER_REPAYMENT_MODAL,
} = centersConstants;

//Get all approved centers list for admin center listing
const getAllCenters = (params) => {
  return (dispatch) => {
    dispatch(
      custom(APPROVED_CENTERS_LIST, globalSystemConstants.SPINNER_ACTIVATE)
    );

    centersService
      .getAllCenters(params)
      .then((response) => {
        dispatch(success(response, APPROVED_CENTERS_LIST));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            APPROVED_CENTERS_LIST,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const getAllCentersList = () => {
  return (dispatch) => {
    centersService
      .getAllCentersList()
      .then((response) => {
        dispatch(success(response, CENTERS_LIST));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      });
  };
};

//Get center profile
const getCenterById = (id, onSuccess) => {
  return (dispatch) => {
    dispatch(custom(CENTER_DATA_BY_ID, globalSystemConstants.SPINNER_ACTIVATE));

    centersService
      .getCenterById(id)
      .then((response) => {
        dispatch(success(response, CENTER_DATA_BY_ID));
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(CENTER_DATA_BY_ID, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

//Get all approved requested centers list for admin center listing
const getApprovalRequestedCenters = (params) => {
  return (dispatch) => {
    dispatch(
      custom(PENDING_CENTERS_LIST, globalSystemConstants.SPINNER_ACTIVATE)
    );

    centersService
      .getApprovalRequestedCenters(params)
      .then((response) => {
        dispatch(success(response, PENDING_CENTERS_LIST));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(PENDING_CENTERS_LIST, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

//Approve/Reject center and nafes
const approveCenters = (data) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );

    centersService
      .approveCenters(data)
      .then((response) => {
        ToastifyService.showSuccess(i18next.t(response));
        dispatch(getCenterById(data.centerId));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
        dispatch(success(false, userConstants.OPEN_MODAL));
        dispatch(instructorActions.toggleViewModal(false));
      });
  };
};

//Approve/Reject center spot
const approveCenterSpot = (data, centerId, setAddLocationModal) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );

    centersService
      .approveCenterSpot(data)
      .then((response) => {
        ToastifyService.showSuccess(i18next.t(response));
        dispatch(getCenterById(centerId));
        setAddLocationModal(false);
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
        dispatch(success(false, userConstants.OPEN_MODAL));
        dispatch(instructorActions.toggleViewModal(false));
      });
  };
};

//Update center profile
const updateCenterProfile = (data) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );

    centersService
      .updateCenterProfile(data)
      .then((response) => {
        ToastifyService.showSuccess(i18next.t(response));
        dispatch(getCenterById(data.id));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

//Enable/Disable center
const enableDisableCenter = (centerId) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );

    centersService
      .enableDisableCenter(centerId)
      .then((response) => {
        ToastifyService.showSuccess(i18next.t(response));
        dispatch(getCenterById(centerId));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

//Update Nafes
const updateNafes = (data, centerId, setupdateNafesModal) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );

    centersService
      .updateNafes(data)
      .then((response) => {
        ToastifyService.showSuccess(i18next.t(response));
        dispatch(getCenterById(centerId));
        setupdateNafesModal(false);
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const getCenterLogo = (centerId) => {
  return (dispatch) => {
    dispatch(custom(GET_CENTER_LOGO, globalSystemConstants.SPINNER_ACTIVATE));
    centersService
      .getCenterLogo(centerId)
      .then((response) => {
        dispatch(success(response, GET_CENTER_LOGO));
      })
      .catch((error) => {
        console.error(i18next.t(error));
      })
      .finally(() =>
        dispatch(
          custom(GET_CENTER_LOGO, globalSystemConstants.SPINNER_DEACTIVATE)
        )
      );
  };
};

const uploadCenterLogo = (formData, centerId) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );

    centersService
      .uploadCenterLogo(formData)
      .then((message) => {
        ToastifyService.showSuccess(i18next.t(message));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const setCenterLogoPreview = (data) => {
  return (dispatch) => {
    try {
      dispatch(success(data, GET_CENTER_LOGO));
    } catch (error) {
      ToastifyService.showError(error);
    }
  };
};

const addCenterSpot = (data, centerId, setAddLocationModal) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );

    centersService
      .addCenterSpot(data, centerId)
      .then((message) => {
        ToastifyService.showSuccess(i18next.t(message));
        dispatch(getCenterById(centerId));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
        dispatch(success(false, userConstants.OPEN_MODAL));
        setAddLocationModal(false);
      });
  };
};

const editPrivateCenterSpot = (data, centerId, setAddLocationModal) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );

    centersService
      .editPrivateCenterSpot(data)
      .then((message) => {
        ToastifyService.showSuccess(i18next.t(message));
        dispatch(getCenterById(centerId));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
        dispatch(success(false, userConstants.OPEN_MODAL));
        setAddLocationModal(false);
      });
  };
};

const editPublicCenterSpot = (data, centerId, setAddLocationModal) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );

    centersService
      .editPublicCenterSpot(data)
      .then((message) => {
        ToastifyService.showSuccess(i18next.t(message));
        dispatch(getCenterById(centerId));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
        dispatch(success(false, userConstants.OPEN_MODAL));
        setAddLocationModal(false);
      });
  };
};

//Get center spot by id
const getCenterSpotById = (id) => {
  return (dispatch) => {
    dispatch(
      custom(CENTER_SPOT_DATA_BY_ID, globalSystemConstants.SPINNER_ACTIVATE)
    );

    centersService
      .getCenterSpotById(id)
      .then((response) => {
        dispatch(success(response, CENTER_SPOT_DATA_BY_ID));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            CENTER_SPOT_DATA_BY_ID,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const exportCenterData = (gridState, requestType) => {
  return (dispatch) => {
    centersService
      .exportCenterData(gridState, requestType)
      .then((response) => {
        downloadBase64File(
          response.content,
          contentType.CSV,
          response.fileName
        );
      })
      .catch((error) => {
        ToastifyService.showError(error);
      });
  };
};

const centerPayment = (checkout, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    centersService
      .centerPayment(checkout)
      .then((response) => {
        if (onSuccess) {
          onSuccess();
        }
        if (response) {
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const centerPaymentWithSavedCard = (data, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    centersService
      .centerPaymentWithSavedCard(data)
      .then((response) => {
        if (onSuccess) {
          onSuccess();
        }
        ToastifyService.showSuccess(response);
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const toggleCenterRepaymentModal = (flag) => {
  return (dispatch) => dispatch(success(flag, IS_CENTER_REPAYMENT_MODAL));
};

const centerReApprovalRequest = (centerId, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    centersService
      .centerReApprovalRequest(centerId)
      .then((response) => {
        if (onSuccess) {
          onSuccess();
        }
        ToastifyService.showSuccess(response);
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const updateCenterHeadInstructorDetail = (data, centerId) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );

    centersService
      .updateCenterHeadInstructorDetail(data)
      .then((response) => {
        ToastifyService.showSuccess(i18next.t(response));
        dispatch(getCenterById(centerId));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const cancelMembership = (centerId, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    centersService
      .cancelMembership(centerId)
      .then((response) => {
        if (onSuccess) {
          onSuccess();
        }
        if (response) {
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

export const centersActions = {
  getAllCenters,
  getCenterById,
  getApprovalRequestedCenters,
  approveCenters,
  approveCenterSpot,
  updateCenterProfile,
  enableDisableCenter,
  updateNafes,
  getCenterLogo,
  uploadCenterLogo,
  setCenterLogoPreview,
  addCenterSpot,
  editPrivateCenterSpot,
  editPublicCenterSpot,
  getCenterSpotById,
  exportCenterData,
  getAllCentersList,
  centerPayment,
  centerPaymentWithSavedCard,
  toggleCenterRepaymentModal,
  centerReApprovalRequest,
  updateCenterHeadInstructorDetail,
  cancelMembership,
};
